export const hederItems = [
  "ABOUT",
  "WORK",
  "ENGAGEMENTS",
  "CULTURE",
  "NEWS",
  "CONTACT",
]; 

export const heroContent = {
  brand: "BASIC/DEPT",
  copyright: "®",
  reelText: ["PLAY", "REEL"],
  title: "BASIC/DEPT°",
  yearText: "2010-22",
 heroImage:
    "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=80",
};
export const aboutSectionData = {
  description:
    "BASIC/DEPT® is a global branding and digital design agency building products, services, and eCommerce experiences that turn cultural values into company value.",
  buttonText: "SEE THE WORK",
  logoText: "B/D®",
};
export const workSectionData = {
  items: [
    {
      id: 1,
      title: "PATAGONIA",
      description:
        "AN ECOMMERCE EXPERIENCE DRIVEN BY PATAGONIA'S BRAND MISSION",
      image:
        "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=80",
    },
    {
      id: 2,
      title: "WILSON",
      description:
        "A CENTURY-OLD SPORTS BRAND FINDING ITS PLACE IN CULTURE",
      image:
        "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=900&q=80",
    },
    {
      id: 3,
      title: "GOOGLE STORE",
      description:
        "AN ECOMMERCE EXPERIENCE HELPING GOOGLE BRING ITS HARDWARE TO PEOPLE ACROSS THE GLOBE",
      image:
        "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=900&q=80",
    },
  ],
};
export const featuredEngagementsData = {
  current: "01",
  total: "05",
  title: ["FEATURED", "ENGAGEMENTS"],
  items: [
    {
      id: 1,
      brand: "Google",
      heading: "GOOGLE",
      description:
        "Our embedded partnership with Google is as deep as it gets. We’re the lead creative agency for Google Store and provide strategy, design, and prototyping to other divisions. Learn more about our partnership here.",
    },
    {
      id: 2,
      brand: "KFC",
      heading: "KFC",
      description:
        "An award-winning global, digital transformation engagement spanning eCommerce, mobile app, and new drive thru experiences. Bringing KFC’s brand story to life while making it easier for customers to buy chicken. Learn more about our partnership here.",
    },
    {
      id: 3,
      brand: "Wilson",
      heading: "WILSON",
      description:
        "A reimagining of Wilson’s brand visual identity, and brand campaign, to support a new product drop and the launch of the first brick and mortar retail location in the brand’s 108-year history. Read our full case study here.",
    },
    {
      id: 4,
      brand: "AT&T",
      heading: "AT&T",
      description:
        "Redefining a global communications brand through digital design systems, product thinking, and scalable experiences built for one of the largest telecom companies in the world.",
    },
    {
      id: 5,
      brand: "Patagonia",
      heading: "PATAGONIA",
      description:
        "Building meaningful digital commerce experiences that translate brand mission into practical, usable, and high-performing customer journeys across platforms.",
    },
  ],
};
export const cultureSectionData = {
  topLabel: "BASIC/DEPT®",
bottomSection: {
  accent: "FEATURED",
  titleTop: "FEATURED",
  titleBottom: "NEWS",
},  items: [
    {
      id: 1,
      titleLines: ["HELPS", "BRANDS", "CONNECT", "W/CULTURE"],
      meta: "ADWEEK (AGENCY SPOTLIGHT)",
      buttonText: "ABOUT US",
    },
    {
      id: 2,
      titleLines: ["CONNECT", "W/CULTURE"],
      meta: "ADWEEK (AGENCY SPOTLIGHT)",
      buttonText: "ABOUT US",
    },  
  ],
  images: {
    top: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=1200&q=80",
    middle: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=1200&q=80",
    bottom: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=1200&q=80",
  },
};
export const newsSectionData = {
  items: [
    {
      id: 1,
      title: "BASIC® EARNS 12 NOMINATIONS IN 26TH ANNUAL WEBBY AWARDS",
      category: "AWARDS",
      date: "04.05.22",
      image:
        "https://images.unsplash.com/photo-1558655146-9f40138edfeb?auto=format&fit=crop&w=1200&q=80",
    },
    {
      id: 2,
      title: "ENVIRONMENTAL IMPACT AT THE INAUGURAL ANTHEM AWARDS",
      category: "AWARDS",
      date: "02.25.22",
      image:
        "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1200&q=80",
    },
    {
      id: 3,
      title: "COWBOY AND BASIC® RECOGNIZED ACROSS 8 CATEGORIES",
      category: "AWARDS",
      date: "12.08.21",
      image:
        "https://images.unsplash.com/photo-1558981806-ec527fa84c39?auto=format&fit=crop&w=1200&q=80",
    },
    {
      id: 4,
      title: "FAST CO.: BASIC® AND KFC TEAM UP FOR A DIGITAL OVERHAUL",
      category: "PRESS",
      date: "11.30.21",
      image:
        "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=1200&q=80",
    },
    {
      id: 5,
      title:
        "BASIC® AND WEBEX CHAMPION “HYBRID COLLABORATION” AS NEXT EVOLUTION OF WORKPLACE CULTURE",
      category: "PRESS",
      date: "08.19.21",
      image:
        "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1200&q=80",
    },
    {
      id: 6,
      title: "BASIC RECOGNIZED WITH 2020 STAR AWARD FOR TECHNOLOGY",
      category: "AWARDS",
      date: "08.02.21",
      image:
        "https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=1200&q=80",
    },
    {
      id: 7,
      title: "BASIC® EXPANDS THE EXECUTIVE TEAM",
      category: "PRESS",
      date: "06.17.21",
      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=1200&q=80",
    },
  ],
};
export const footerSectionData = {
  logo: "B/D®",
  description: [
    "We collaborate with ambitious brands",
    "and people. Let's build.",
  ],
  email: "moaazqubes12@gmail.com",
  phone: "+963959051812", 
  links: [
    "STAY IN THE KNOW",
    "SOCIAL",
    "INITIATIVES",
    "OFFICES",
  ],
};